<template>
  <section>
    <!-- Componentes externos -->
    <crear-actualizar-horario />
    <ModificarHorario />
    <h3 class="primary--text">
      <v-icon color="primary">schedule</v-icon> Crear horarios
    </h3>
    <v-card>
      <v-card-text>
        <v-tooltip bottom>
          <v-btn
            color="primary"
            dark
            @click.native.stop="crearActualizarHorario({})"
            slot="activator"
            ><v-icon dark>add</v-icon> {{ $t("common.add") }}</v-btn
          >
          <span>Agregar Horario</span>
        </v-tooltip>

        <v-data-table
          class="tabla-comprimida-light"
          :headers="headers"
          :items="horarios"
          item-key="id_horario"
          no-data-text="Sin datos"
          disable-initial-sort
          :rows-per-page-items="[10, 25, { text: 'Todos', value: -1 }]"
        >
          <template slot="items" slot-scope="items">
            <tr class="fila-principal">
              <td class="text-xs-center">{{ items.item.grupo }}</td>
              <td style="width: 1%;">
                <table class="tabla-jornadas">
                  <tr
                    v-for="(jornada, index) in items.item.jornadas"
                    :key="index"
                  >
                    <td>
                      <span class="material-symbols-outlined">
                        {{
                          jornadas.filter(
                            ele => ele.id == jornada.id_jornada
                          )[0].icono
                        }}
                      </span>
                    </td>
                    <td>
                      <b
                        >{{
                          jornadas.filter(
                            ele => ele.id == jornada.id_jornada
                          )[0].descripcion
                        }}:
                      </b>
                    </td>
                    <td>{{ jornada.hora_inicio }}</td>
                    <td>
                      {{ jornada.hora_fin }}
                    </td>
                  </tr>
                </table>

                <!-- <ul class="">
                  <li
                    
                  >
                   
                    - 
                  </li>
                </ul> -->
              </td>
              <td colspan="4">
                <tr
                  v-for="(horario, index) in items.item.horarios"
                  :key="index"
                  class="multifila-horario"
                >
                  <td class="text-xs-center">
                    {{ horario.descripcion }}
                  </td>
                  <td class="text-xs-center">{{ horario.joranada }}</td>
                  <td class="text-xs-center">
                    {{ horario.horario }}
                  </td>
                  <td class="text-xs-center">
                    {{ horario.horario_2 }}
                  </td>
                </tr>
              </td>

              <td>
                <v-tooltip bottom>
                  <v-btn
                    icon
                    slot="activator"
                    @click.native="crearActualizarHorario(items.item)"
                    color="primary"
                    dark
                    outline
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <span>Editar registro</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    color="red"
                    icon
                    slot="activator"
                    @click="eliminarHorario(items.item)"
                    dark
                    outline
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                  <span>Eliminar registro</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrearActualizarHorario from "./dialogs/CrearActualizarHorario"; // Componente de creación y actualización
import ModificarHorario from "./dialogs/ModificarHorario";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [],
  // Variables iniciales del componente
  data() {
    return {
      // Cabecera de la tabla
      headers: [
        { text: "Grupo", value: "grupo", align: "center" },
        { text: "Jornadas", value: "jornadas", align: "center" },
        { text: "Descripción", value: "descripcion", align: "center" },
        { text: "Jornada", value: "joranada", align: "center" },
        { text: "Hora inicio", value: "horario", align: "center" },
        { text: "Hora fin", value: "horario_2", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      horarios: [],
      jornadas: []
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    await this.cargarJornadas();
    await this.cargarHorarios();
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    this.$bus.$on("closeDialogCrearHorario", async () => {
      await this.cargarHorarios();
    });
    this.$bus.$on("closeDialogModificarHorario", async () => {
      await this.cargarHorarios();
    });
  },
  // Métodos y funciones del componente
  methods: {
    async cargarHorarios() {
      try {
        //cargar horarios:
        let respuesta = await this.$service.graphql({
          query: `
            query {
              runQuery(consulta:"select * from control.v_horario_agrupado "){
                respuesta
              }
            }
				`
        });
        // select * from control.v_horarios_con_rangos vs where vs.id_estado <> 2 order by vs.id_horario DESC
        var l_tmp = respuesta.runQuery.respuesta;
        // Convertimos los string a JSON
        l_tmp = l_tmp.map(objeto => ({
          ...objeto,
          horarios: JSON.parse(objeto.horarios).sort((a, b) =>
            a.horario.localeCompare(b.horario)
          ),
          jornadas: JSON.parse(objeto.jornadas)
        }));
        this.horarios = l_tmp;
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para cargar las jornadas
    async cargarJornadas() {
      try {
        //cargar horarios:
        let respuesta = await this.$service.graphql({
          query: `
            query {
              jornadas{
                rows{
                  id
                  descripcion
                  sigla
                  icono
                }
              }
            }
				`
        });
        var l_tmp = respuesta.jornadas.rows;
        this.jornadas = l_tmp;
      } catch (error) {
        console.log(error);
      }
    },
    crearActualizarHorario(item) {
      this.$bus.$emit("openDialogCrearActualizarHorario", item);
    },
    modificarHorario(item) {
      this.$bus.$emit("openDialogModificarHorario", item);
    },
    async eliminarHorario(item) {
      try {
        this.$confirm(
          "¿Esta seguro de eliminar el registro, esta acción es irreversible?",
          async () => {
            let respuesta = await this.$service.graphql({
              query: `
              query{
                runQuery(consulta:"select control.fn_eliminar_horario_rangos(${parseInt(
                  item.grupo
                )})"){
                  respuesta
                }
              }
            `
            });
            respuesta = respuesta.runQuery.respuesta[0].fn_eliminar_horario_rangos.split(
              "|"
            );
            if (respuesta[0] == "1") {
              this.$message.success("El registro fué eliminado exitosamente");
            } else {
              this.$message.info(respuesta[1]);
            }
            await this.cargarHorarios();
          }
        );
      } catch (error) {
        console.log(error);
      }
    }
  },
  // Definición de componentes importados
  components: {
    CrearActualizarHorario,
    ModificarHorario
  }
};
</script>

<style scoped lang="scss">
.fila-principal:hover {
  background: rgba(121, 213, 255, 0.281) !important;
}
.multifila-horario {
  display: flex;
  flex: 1;
  &:hover {
    background: rgba(121, 213, 255, 0.082) !important;
  }
  td {
    text-align: center;
    width: 25%;
    height: 100%;
  }
}
.tabla-jornadas {
  width: auto;
  tr {
    width: auto;
    td:nth-child(1) {
      color: rgb(15, 82, 145);
      span {
        font-size: 1.1rem;
      }
    }

    td:nth-child(2) {
      letter-spacing: -1px;
      width: 100%;
    }

    td {
      line-height: 1.1;
      font-size: 0.9rem;
      height: auto;
      padding: 0rem 0.1rem !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/horario/Index.vue